<template>
  <div>
    <loading :active.sync="isLoading" :can-cancel="false" is-full-page="true"></loading>
    <div>
      <!--p>
      {{ log }}
      </p-->
    </div>
  </div>
</template>
<script>
import liff from "@line/liff";
import Loading from "vue-loading-overlay";
//import VueInstant from "VueInstant";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  components: {
    loading: Loading,
  },
  data() {
    return {
      console: [],

      isLoading: true,
      log: "",
    };
  },

  computed: {},
  beforeMount() {
    console.log("beforeMount");
    //this.console.push('beforeMount');
    //this.console.push(this.$route);
    //--console.log("mounted");
    //localStorage.setItem("liffId",  this.$route.params.liffId !== undefined ? this.$route.params.liffId : this.$route.query.liffId);
    //this.console.push('mounted');
    //this.console.push(this.$route);
    if (this.$route.params.liffId !== undefined) {
      //localStorage.clear();
      localStorage.removeItem("vuex");
      localStorage.setItem("redirectTo", this.$route.params.redirectTo);
      //localStorage.setItem("liffId", this.$route.params.liffId);
      localStorage.setItem("tempLiffId", this.$route.params.liffId);
    }
    if (this.$route.query.apiKey != "" && this.$route.query.apiKey !== undefined) {
      localStorage.setItem("apiKey", this.$route.query.apiKey);
    }
    if (this.$route.query.custId != "" && this.$route.query.custId !== undefined) {
      localStorage.setItem("custId", this.$route.query.custId);
    }
    ////--console.log(this.$route);
    ////--console.log("AUTH Line 51 route params")
    //--console.log(this.$route.params);
    if (
      this.$route.params.redirectTo != "" &&
      this.$route.params.redirectTo !== undefined
    ) {
      //--console.log("SET REDIRECT");
      localStorage.setItem("redirectTo", this.$route.params.redirectTo);
    }
    //--console.log(localStorage.getItem("redirectTo"));
    //localStorage.setItem("liffId",  this.$route.params.liffId !== undefined ? this.$route.params.liffId : this.$route.query.liffId);
    ////--console.log(localStorage.getItem("liffId"));
    ////--console.log(this.$store.state.profile);
    //this.console.push(this.$store);
    //this.console.push( localStorage.getItem("liffId"));
    //this.$store.dispatch("getCustInfoById", localStorage.getItem("liffId")
    if (this.$route.query.liffId != "" && this.$route.query.liffId !== undefined) {
      localStorage.setItem("tempLiffId", this.$route.query.liffId);
    } else if (
      this.$route.params.liffId != "" &&
      this.$route.params.liffId !== undefined
    ) {
      localStorage.setItem("tempLiffId", this.$route.params.liffId);
    }
    this.log = JSON.stringify(this.$route.params);
    this.log =
      this.log +
      " <br>  " +
      localStorage.getItem("liffId") +
      " <br> " +
      localStorage.getItem("custId") +
      " <br> " +
      localStorage.getItem("apiKey") +
      " <br>  " +
      JSON.stringify(this.$store.state.profile);

    //----------------------------------
    /*
    this.$store.dispatch("checkExistedMember", {
      //liffId: localStorage.getItem("tempLiffId"),
      line_id: localStorage.getItem("line_id"),
      custId: localStorage.getItem("custId"),
      apiKey: localStorage.getItem("apiKey"),
    });
    */
  },
  mounted() {
    console.log("auth mouted");
    console.log(localStorage.getItem("tempLiffId"));
    console.log(localStorage.getItem("liffId"));
    console.log(localStorage.getItem("custId"));

    this.$store.dispatch("setContent", {
      custId: localStorage.getItem("custId"),
    });

    //console.log(liff.isLoggedIn());

    if (localStorage.getItem("liffId") !== undefined ||  localStorage.getItem("tempLiffId") !== undefined ) {
      console.log("new init line");
      liff
        .init({
          liffId: localStorage.getItem("tempLiffId"),
          withLoginOnExternalBrowser: true,
        })
        .then(() => {
          //-----------------------------------------
          if (!liff.isLoggedIn() && !liff.isInClient()) {
            console.log("LINE LOGIN");
            this.console.push("LINE LOGIN");

            liff.login();
          } else {
            //--console.log("LINE LOGGED");
          }

          //liff.login();
          //-----------------------------------------
          console.log(liff.isLoggedIn());

          liff
            .getProfile()
            .then((profile) => {
              console.log("get line profile");
              console.log(profile);
              localStorage.setItem("liffId", localStorage.getItem("tempLiffId"));
              //--console.log("SET PROFILE");
              localStorage.setItem("line_id", profile.userId);
              localStorage.setItem("line_email", liff.getDecodedIDToken().email || "");
              localStorage.setItem("line_name", profile.displayName);
              localStorage.setItem("line_img", profile.pictureUrl);
              profile.email = liff.getDecodedIDToken().email || "";

              this.$store.dispatch("setLineProfile", profile);
              this.$store.dispatch("setContent", {
                custId: localStorage.getItem("custId"),
              });
              this.lineInfo = profile;
              //--console.log("getMembers information");
              this.$store.dispatch("listProducts", {
                custId: localStorage.getItem("custId"),
              });
              this.$store
                .dispatch("checkExistedMember", {
                  line_id: localStorage.getItem("line_id"),
                  custId: localStorage.getItem("custId"),
                  apiKey: localStorage.getItem("apiKey"),
                })
                .then(() => {
                  //--console.log("member Info");
                  //--console.log(memberInfo);
                  this.$store.dispatch("preparePostcodeProvinceData", {});

                  //----------------------

                  if (
                    localStorage.getItem("redirectTo") &&
                    this.$store.state.profile._id !== undefined
                  ) {
                    //--console.log("redirectTo");
                    this.redirectTo = localStorage.getItem("redirectTo");
                    //--console.log("SET REDIRECT");

                    if (this.redirectTo != "Register") {
                      localStorage.removeItem("redirectTo");
                      this.$router.push({
                        name: this.redirectTo,
                        /*query: {
                                      custId: localStorage.getItem("custId"),
                                      apiKey: localStorage.getItem("apiKey"),
                                    },
                                    */
                      });
                    } else {
                      localStorage.removeItem("redirectTo");
                      this.$router.push({
                        name: "Profile",
                      });
                    }
                  } else {
                    //--console.log("no profile");
                    //--console.log(
                    //  "--------------  this.$store.state.profile -----------------"
                    //);
                    //--console.log(this.$store.state.profile);
                    //--console.log(typeof this.$store.state.profile._id);

                    if (this.$store.state.profile._id === undefined) {
                      let query = {};
                      if (localStorage.getItem("redirectTo") != "") {
                        query = {
                          redirectTo: localStorage.getItem("redirectTo"),
                        };
                      }
                      //--console.log("Redirect to register");
                      this.$router.push({
                        name: "Register",
                        query: query,
                      });
                    } else {
                      this.$router.push({
                        name: "Profile",
                      });
                    }
                  }
                });
            })
            .catch((err) => {
              console.log(err);
            });

          //--------------------------------
          /*
                  if(localStorage.getItem("redirectTo") !== undefined ){
                    //--console.log("LOGGED AND REDIRECT");
                    this.$router.push({
                        name: this.$route.params.redirectTo,
                      });
                    }else{
                      this.$router.push({
                        name: "Profile",
                      });
                }
                */
          //-----------------------------------
        })
        .catch((err) => {
          console.log("Line login err!");
          console.log(err);
           localStorage.clear();
     
          //alert(localStorage.getItem("tempLiffId"));
          //alert(localStorage.getItem("liffId"));
           /*alert(liff.isInClient());
          alert(liff.isLoggedIn());
          alert(liff.isApiAvailable());
          alert(liff.isInClient());
          liff.login({liffId:localStorage.getItem("liffId") || localStorage.getItem("tempLiffId")});
          alert(liff.getAccessToken());
          */
          window.location.reload(true);
        });

      //--console.log("mounted");
      //--console.log(this.$route);

      /*
      if (
      this.$route.query.liffId !== undefined || this.$route.params.liffId !== undefined
    ) {

      if(localStorage.getItem("liffId") != null || localStorage.getItem("liffId") !== undefined ){
        if((this.$route.query.liffId !== undefined) && (localStorage.getItem("liffId") != undefined)){
          //--console.log("Clear!");
          if(this.$route.query.liffId != localStorage.getItem("liffId")){
            localStorage.clear();
           }

         }
      }
      localStorage.setItem("liffId",this.$route.query.liffId || this.$route.params.liffId);
        //--console.log('END AUTH.VUE');
    }
    */
      //--console.log("END AUTH.VUE");
    } else {
      // if same
      /*
      console.log("LINE LIFF LOGGED SECTION");
      console.log(localStorage.getItem("tempLiffId"));
      console.log(localStorage.getItem("liffId"));
      liff
        .init({
          liffId: localStorage.getItem("liffId"),
          withLoginOnExternalBrowser: true,
        })
        .then(() => {
          liff
            .getProfile()
            .then((profile) => {
              console.log("get line profile Logged");
              console.log(profile);
              localStorage.setItem("liffId", localStorage.getItem("tempLiffId"));
              //--console.log("SET PROFILE");
              localStorage.setItem("line_id", profile.userId);
              localStorage.setItem("line_email", liff.getDecodedIDToken().email);
              localStorage.setItem("line_name", profile.displayName);
              localStorage.setItem("line_img", profile.pictureUrl);
              profile.email = liff.getDecodedIDToken().email;

              this.$store.dispatch("setLineProfile", profile);
              this.$store.dispatch("setContent", {
                custId: localStorage.getItem("custId"),
              });
              this.lineInfo = profile;

              this.$store.dispatch("listProducts", {
                custId: localStorage.getItem("custId"),
              });
              this.$store
                .dispatch("checkExistedMember", {
                  line_id: localStorage.getItem("line_id"),
                  custId: localStorage.getItem("custId"),
                  apiKey: localStorage.getItem("apiKey"),
                })
                .then(() => {
                  //--console.log("member Info");
                  //--console.log(memberInfo);
                  this.$store.dispatch("preparePostcodeProvinceData", {});

                  //----------------------

                  if (
                    localStorage.getItem("redirectTo") &&
                    this.$store.state.profile._id !== undefined
                  ) {
                    //--console.log("redirectTo");
                    this.redirectTo = localStorage.getItem("redirectTo");
                    //--console.log("SET REDIRECT");

                    if (this.redirectTo != "Register") {
                      localStorage.removeItem("redirectTo");
                      this.$router.push({
                        name: this.redirectTo,
                      });
                    } else {
                      localStorage.removeItem("redirectTo");
                      this.$router.push({
                        name: "Profile",
                      });
                    }
                  } else {
                    //--console.log("no profile");
                    //--console.log("--------------  this.$store.state.profile -----------------");
                    //--console.log(this.$store.state.profile);
                    //--console.log(typeof this.$store.state.profile._id);

                    if (this.$store.state.profile._id === undefined) {
                      let query = {};
                      if (localStorage.getItem("redirectTo") != "") {
                        query = {
                          redirectTo: localStorage.getItem("redirectTo"),
                        };
                      }
                      //--console.log("Redirect to register");
                      this.$router.push({
                        name: "Register",
                        query: query,
                      });
                    } else {
                      this.$router.push({
                        name: "Profile",
                      });
                    }
                  }
                });
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch((err) => {
          console.log(err);
        });
        */
      localStorage.clear();
     
      //alert(localStorage.getItem("tempLiffId"));
      //alert(localStorage.getItem("liffId"));
       /*alert(liff.isInClient());
      alert(liff.isLoggedIn());
      alert(liff.isApiAvailable());
      alert(liff.isInClient());
      liff.login({liffId:localStorage.getItem("liffId") || localStorage.getItem("tempLiffId")});
      alert(liff.getAccessToken());
      */
      window.location.reload(true);

    }
  },
  methods: {},
};
</script>
